import type { PersistConfig } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { expireTransform, transform } from '@/helpers/transform-persist';
import type { CarrierListStateInterface } from '@/types/carrier-types';
import type { RolesStateInterface } from './slices/masters/roles/roleSlice';
import type { UserStateInterface } from './slices/masters/user/userApiSlice';
import {
  staffDMyTaskInitialState,
  type StaffDashboardStateInterface,
} from './slices/main/dashboard/staffDashboardMyTaskSlice';

const fourHours = 14400;

export const persistRolesConfig: PersistConfig<RolesStateInterface> = {
  key: 'roles',
  storage,
  blacklist: ['addNewRole'],
  transforms: [transform],
};

// export const persistCarrierConfig: PersistConfig<CarrierApiStateInterface> = {
//   key: 'carrier',
//   storage,
//   whitelist: ['carriers'],
//   transforms: [transform],
// };

export const persistCarrierListConfig: PersistConfig<CarrierListStateInterface> =
  {
    key: 'carrierList',
    storage,
  };

export const persistStaffDashboardConfig: PersistConfig<StaffDashboardStateInterface> =
  {
    key: 'staff-dashboard',
    storage,
    transforms: [expireTransform(fourHours, staffDMyTaskInitialState)],
  };

export const persistUserConfig: PersistConfig<UserStateInterface> = {
  key: 'user',
  storage,
  blacklist: ['postAWSSignUp', 'postAddUser'],
  transforms: [transform],
};
